module.exports = __webpack_public_path__ + "static/media/tuev-cert.7e30636e.svg";